export default "__VITE_ASSET__XbBfzn2I__"